import {
  memo,
  useEffect,
  useState,
  forwardRef,
  useMemo,
  useRef,
  useCallback,
  type FC,
  type Dispatch,
  type SetStateAction,
  Fragment,
} from "react";
import Icon from "../../../assets/TakyonDesignSystem/components/Icon/Icon";
import { Hotel, HotelDetails } from "../../../assets/Services/wsSearch";
import IconNew from "../../../assets/TakyonDesignSystem/components/Icon/Icon";
import { useTranslation } from "react-i18next";
import Button from "../../../assets/TakyonDesignSystem/components/Button/Button";
import { AnimatePresence, motion } from "framer-motion";
import { closeModal, openModal } from "../../../assets/Utils/modal";
import { SMALL_SCREEN, x_LARGE_SCREEN } from "../../../assets/Utils/generic";
import { fireTagManagerEvent } from "../../../assets/Services/tagmanager";
import { useMediaQuery } from "react-responsive";
import { useSearchParams } from "react-router-dom";
import imageBadgePlus from "../../../assets/img/directsearch/badge_plus.avif";
import imageBadgePlusInverted from "../../../assets/img/directsearch/badge_plus_inverted.avif";
import imageBadgePhoneNumber from "../../../assets/img/directsearch/badge_phone_number.avif";
import loadingGif from "../../../assets/img/icons/search.gif";
import HotelsMap from "./HotelsMap";
import { selectUser } from "../../../redux/slices/userSlice";
import { Form } from "react-bootstrap";
import { SortHotelsBy } from "../../../assets/Services/wsSearch";
import { parseParams, useSearch } from "../../hooks/useSearch";
import LoadingBar from "./LoadingBar";
import DsFeedback from "./DsFeedback";
import { useHotelImpressions } from "../../hooks/useHotelImpressions";
import ResultSkeletonList from "./Skeleton/ResultSkeletonList";
import MapInfoHotel from "./MapInfoHotel";
import { signal } from "@preact/signals-react";
import FiltersModal from "./FiltersModal";
import IconInfo from "../../../assets/icons/IconInfo";
import IconFilter from "../../../assets/icons/IconFilter";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
  type CarouselApi,
} from "../../components/Carousel/Carousel";

import DirectSearchBadge from "./DirectSearchBadge";
import ImageWithFallback from "../../components/ImageWithFallback/ImageWithFallback";

import IconStar from "../../../assets/icons/IconStar";

import {
  type AutocompleteLocation,
  autocomplete,
} from "../../../assets/Utils/search";

import DestinationModal from "./DestinationModal";

import { debounce, isEqual } from "lodash";
import { addDays, format, differenceInMinutes } from "date-fns";

import { getLocaleLanguage } from "../../../assets/Services/i18next";

import { enUS, es, it } from "date-fns/locale";

import { LANG } from "../../../config/Lang";
import { advantagesMap } from "../../../config/advantages";
import { type Range } from "react-date-range";
import IconTelephone from "../../../assets/icons/IconTelephone";

import Select from "../../../assets/TakyonDesignSystem/components/Select/Select";

import { cn } from "../../../assets/Utils/generic";

import {
  ANALYTICS_SORT_BY,
  ANALYTICS_SOURCE,
  ANALYTICS_SEARCH_TYPE,
  ANALYTICS_DETAILS_SECTION,
} from "../../../config/analytics";

import { useSelector } from "react-redux";
import { currencySymbols } from "../../../assets/Utils/prices";
import CollectionController from "../../../assets/Controllers/CollectionController";
import IconThumbsUp from "../../../assets/icons/IconThumbsUp";
import IconThumbsDown from "../../../assets/icons/IconThumbsDown";
import DatesModal from "./DatesModal";
import GuestsModal from "./GuestsModal";
import UnavailableCarousel from "./UnavailableCarousel";
import CarouselWrapper from "./CarouselWrapper";
import TagsCarousel from "./TagsCarousel";
import { FullScreenCarousel } from "../DetailPage/FullScreenCarousel";
import PlusModal from "./PlusModal";
import { getDisplayPrice, getOTADeltaPrice } from "./utils";

import IconVerifiedBadge from "../../../assets/icons/IconVerifiedBadge";
import IconWebsite from "../../../assets/icons/IconWebsite";
import IconCopy from "../../../assets/icons/IconCopy";

import Bowser from "bowser";
import { toast } from "react-toastify";
import { useCopyToClipboard } from "../../hooks/hooks";

import IconChevron from "../../../assets/icons/IconChevron";

export const currHotelID = signal<string>("");

const getWebsiteDomainAndPath = (url: string) => {
  try {
    const { hostname, pathname } = new URL(url);
    const cleanHost = hostname.replace(/^www\./, "");

    return cleanHost;
  } catch {
    return null;
  }
};

const HotelResult = memo(
  forwardRef(
    (
      {
        hotel,
        onSelect,
        onCardClick,
        dest_label,
        currentSelected,
        setCurrentSelected,
        listPosition,
        openPlusModal,
      }: {
        hotel: Hotel;
        onSelect(id: string): void;
        onCardClick(hotel: Hotel): void;
        dest_label?: string;
        currentSelected: string;
        setCurrentSelected(id: string): void;
        listPosition: number;
        openPlusModal: () => void;
      },
      ref,
    ) => {
      const { buildRedirectURL, searchParameters } = useSearch();

      const isTabletScreen = useMediaQuery({
        query: "(min-width: 640px) and (max-width: 1023px)",
      });
      const isDesktopScreen = useMediaQuery({ query: "(min-width: 1280px)" });

      const { t } = useTranslation();

      const user = useSelector(selectUser);

      let advantages = hotel.advantagesOnDirectWebsite;
      if (advantages) {
        advantages = advantages.slice(0, 3); // Keep only the first three elements
      }

      const urlGoogle = `https://google.com/search?q=${encodeURIComponent(
        `${hotel.name.replace(/&/g, "")} sito ufficiale ${
          dest_label?.split(",")[0]
        }`,
      )}`;

      const urlWebsite = hotel?.website;

      const fallbackUrl = urlWebsite ?? urlGoogle;

      const images = hotel.images || [];

      const [carouselApi, setCarouselApi] = useState<CarouselApi>();
      const [carouselCurrentSlide, setCarouselCurrentSlide] = useState(0);
      const [carouselSlidesCount, setCarouselSlidesCount] = useState(0);

      useEffect(() => {
        if (!carouselApi) {
          return;
        }
        const updateCarouselState = () => {
          setCarouselCurrentSlide(carouselApi.selectedScrollSnap());
          setCarouselSlidesCount(carouselApi.scrollSnapList().length);
        };

        updateCarouselState();

        carouselApi.on("select", updateCarouselState);

        return () => {
          carouselApi.off("select", updateCarouselState);
        };
      }, [carouselApi]);

      const isExtraDiscountApplied =
        hotel?.isLoyaltyEnabled &&
        hotel?.isLoyaltyEnabledAdmin &&
        hotel?.loyatyDiscountPercentage;

      const highlightedAdvantage = hotel.advantagesOnDirectWebsite?.[0];

      const HighlightedAdvantageIcon =
        advantagesMap[highlightedAdvantage as keyof typeof advantagesMap]?.icon;
      const highlightedAdvantageLabel =
        advantagesMap[highlightedAdvantage as keyof typeof advantagesMap]
          ?.label;

      const openFullScreenCarousel = (startIndex: number) => {
        openModal(
          {
            content: (
              <FullScreenCarousel
                startIndex={startIndex}
                totalImagesCount={images.length}
                imageUrls={images}
                hotelId={hotel._id || ""}
                hotelName={hotel.name || ""}
              />
            ),
            className: "bg-black rounded-none lg:rounded-3xl",
          },
          { hideModalCloseBtn: true },
        );
        fireTagManagerEvent("open_details_section", {
          detail_section: ANALYTICS_DETAILS_SECTION.PHOTO,
          user_id: user?._id ?? null,
        });
      };

      const bowserParser = Bowser.getParser(navigator.userAgent);
      const isMobile = bowserParser.getPlatformType() === "mobile";

      const { copyToClipboard } = useCopyToClipboard();

      if (isTabletScreen || isDesktopScreen) {
        return (
          <motion.button
            onMouseEnter={() => {
              onSelect(hotel._id);
            }}
            onMouseLeave={() => {
              onSelect("");
            }}
            onClick={(e) => {
              e.stopPropagation();
              CollectionController.clickOnCollection(hotel._id, {
                btn: "detail_page",
                directPrice: hotel.availability?.availabilityInfo.value,
                cutPrice: undefined,
                bookingPrice: undefined,
                hotelsPrice: "N/A",
                bookingComId: hotel.bookingId,
                checkin: searchParameters.arrivalDate,
                checkout: searchParameters.departureDate,
              });
              fireTagManagerEvent("open_modal", {
                user_id: user?._id ?? null,
                collection_id: hotel._id,
                collection_name: hotel.name,
                is_available:
                  hotel.availability &&
                  hotel.availability.availabilityInfo.available,
                is_free: !hotel.isActive,
                is_loyalty_enabled:
                  !!hotel.isLoyaltyEnabled && !!hotel?.isLoyaltyEnabledAdmin,
                list_position: listPosition !== -1 ? listPosition : null,
                source: ANALYTICS_SOURCE.LIST,
                stars:
                  hotel.stars && Number(hotel.stars) !== 0
                    ? Number(hotel.stars)
                    : null,
                destination: !!searchParameters.destinationLabel
                  ? searchParameters.destinationLabel
                  : null,
                tag: !!searchParameters.tag ? searchParameters.tag : null,
                includes_benefits: hotel?.advantagesOnDirectWebsite?.length > 0,
              });
              setCurrentSelected(hotel._id);
              onCardClick(hotel);
            }}
            id={hotel._id}
            data-hotel-id={hotel._id}
            data-collection-id={hotel._id}
            data-booking-id={hotel.bookingId}
            title={hotel.name}
            type="button"
            className="hotel-result px-4 border-none group bg-transparent"
            data-selected={currentSelected === hotel._id}
          >
            <div className="flex flex-row gap-3 p-3 rounded-3xl group-hover:bg-[#F8F8F8] group-data-[selected=true]:bg-[#F8F8F8] transition-colors duration-300 min-h-[280px]">
              <div className="relative rounded-2xl size-[256px] border-none box-border bg-[#E8E8E8] overflow-hidden ring-white group-hover:ring-4 group-hover:shadow-xl group-data-[selected=true]:ring-4 group-data-[selected=true]:shadow-xl shrink-0 transition duration-300 aspect-square">
                <Carousel
                  setApi={setCarouselApi}
                  className="size-full [&>div]:size-full"
                >
                  <CarouselContent className="size-full ml-0">
                    {images.slice(0, 8).map((url, index) => (
                      <CarouselItem
                        key={`hotel-img-${index}-${hotel._id}`}
                        className="size-full pl-0 relative"
                      >
                        <ImageWithFallback
                          src={url.replace("square60", "square600")}
                          alt={`${hotel.name} - ${index + 1}`}
                          className="size-full object-cover"
                        />
                        {index === Math.min(images.length, 8) - 1 ? (
                          <button
                            className="border-none absolute size-full flex justify-center items-center top-0 left-0 bg-black bg-opacity-40"
                            onClick={(e) => {
                              e.stopPropagation();
                              openModal({
                                content: (
                                  <div className="flex flex-col">
                                    <div className="relative flex justify-end px-3 items-center box-border border-bottom h-12">
                                      <h3 className="text-sm font-medium text-center mb-0 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
                                        {`${t("ds.photos")} (${images.length})`}
                                      </h3>
                                      <button
                                        type="button"
                                        onClick={closeModal}
                                        className="bg-transparent border-none touch-hitbox relative"
                                      >
                                        <IconNew
                                          icon="close"
                                          className="size-5"
                                        />
                                      </button>
                                    </div>
                                    <div className="overflow-y-auto h-[calc(100dvh-3rem)] px-4 py-3 grid grid-cols-2 gap-4">
                                      {images.map((url, index) => (
                                        <button
                                          type="button"
                                          key={`gallery-img-${index}-${hotel._id}`}
                                          className="bg-transparent border-none"
                                          onClick={() => {
                                            openFullScreenCarousel(index);
                                          }}
                                        >
                                          <ImageWithFallback
                                            src={url.replace(
                                              "square60",
                                              "square600",
                                            )}
                                            alt={`${hotel.name} - ${index + 1}`}
                                            className="w-full object-cover rounded-lg"
                                            style={{
                                              aspectRatio: "1 / 0.8",
                                            }}
                                          />
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                ),
                                className:
                                  "rounded-t-3xl self-end h-[calc(100dvh-1rem)]",
                              });
                            }}
                          >
                            <div className="bg-transparent rounded-xl px-3 py-1 border border-white text-white text-sm font-medium">
                              {t("ds.see_more_photo")}
                            </div>
                          </button>
                        ) : null}
                      </CarouselItem>
                    ))}
                  </CarouselContent>
                  <CarouselPrevious />
                  <CarouselNext />
                </Carousel>
                <div className="absolute left-1/2 -translate-x-1/2 bottom-4 flex items-center gap-1">
                  {carouselSlidesCount > 0 &&
                    Array.from({ length: carouselSlidesCount }).map(
                      (_, index) => (
                        <div
                          key={index}
                          className={`size-2 rounded-full ${
                            carouselCurrentSlide === index
                              ? "bg-white"
                              : "bg-white/50"
                          }`}
                        />
                      ),
                    )}
                </div>
                {hotel.isActive && (
                  <button
                    className="absolute border-none top-2.5 left-2.5 items-center gap-2 bg-white shadow-[0px_0px_20px_5px_rgba(0,_0,_0,_0.25)] rounded-full pl-[0.375rem] pr-3 h-8 flex"
                    onClick={(e) => {
                      e.stopPropagation();
                      openPlusModal();
                    }}
                  >
                    <img
                      src={imageBadgePlus}
                      role="presentation"
                      className="size-5 shrink-0"
                      alt=""
                    />
                    <p className="text-sm text-black">{t("ds.booking_plus")}</p>
                  </button>
                )}
              </div>
              <main className="flex flex-col flex-1">
                <p className="text-sm text-[#747474] gap-1 flex flex-wrap items-center ml-1 line-clamp-1">
                  {hotel.stars && Number(hotel.stars) !== 0 && (
                    <span>
                      {`Hotel ${hotel.stars} ${t("ds.star", {
                        count: Number(hotel.stars),
                      })} |`}
                    </span>
                  )}
                  <span>{hotel.city}</span>
                </p>
                <h3 className="text-xl font-medium mb-0 text-left text-black mt-1 ml-1 line-clamp-1">
                  {hotel.name}
                </h3>
                {!!hotel.reviewScore && !!hotel.reviewCount && (
                  <p className="text-sm flex items-center gap-1 h-fit mt-1 ml-1 text-black">
                    <span>{hotel.reviewScore}</span>
                    <IconStar className="size-3" />
                    <span>
                      {t(
                        `ds.rating_${
                          hotel.reviewScore.toString().split(".")[0]
                        }`,
                      )}
                    </span>
                    <span className="text-[#747474]">
                      {`(${new Intl.NumberFormat(
                        searchParameters.language ?? "en-US",
                      ).format(hotel.reviewCount)})`}
                    </span>
                  </p>
                )}
                <div className="w-full flex justify-between items-start mt-2 flex-1 relative">
                  {hotel.isActive &&
                    !!highlightedAdvantage &&
                    highlightedAdvantageLabel && (
                      <div className="flex justify-center items-center gap-1 shrink-0 absolute left-0 top-0 pl-2 pr-2.5 h-8 bg-[#F8F8F8] rounded-xl group-hover:bg-[#E8E8E8] group-data-[selected=true]:bg-[#E8E8E8] transition-colors duration-300">
                        {HighlightedAdvantageIcon && (
                          <HighlightedAdvantageIcon className="size-3.5 text-black shrink-0" />
                        )}
                        <span className="text-sm text-black">
                          {t(highlightedAdvantageLabel)}
                        </span>
                      </div>
                    )}
                  <div className="flex-1 flex flex-col justify-end h-full pr-1 pb-1">
                    {hotel.availability &&
                    hotel.availability.availabilityInfo.available ? (
                      <div className="flex items-end flex-col pr-1.5">
                        <div className="flex justify-between items-end gap-1">
                          <p className="text-xs text-black">{t("ds.from2")}</p>
                          <p className="text-2xl translate-y-1 text-black font-medium">
                            {getDisplayPrice({
                              availability: hotel.availability,
                              deltaBooking: hotel.deltaPriceBookingCom,
                              deltaHotels: hotel.deltaPriceHotelsCom,
                              lang: searchParameters.language,
                            })}
                          </p>
                        </div>
                        {hotel.availability.availabilityInfo.available ? (
                          <div className="flex items-center justify-end w-full">
                            <p className="text-xs text-[#EF4444]">
                              {getOTADeltaPrice({
                                availability: hotel.availability,
                                deltaBooking: hotel.deltaPriceBookingCom,
                                deltaHotels: hotel.deltaPriceHotelsCom,
                                lang: searchParameters.language,
                              })}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <div className="flex rounded-lg px-2 py-1 justify-center items-center bg-[#E8E8E8]">
                        <p className="text-xs text-[#747474]">
                          {t("ds.no_availability")}
                        </p>
                      </div>
                    )}
                    {hotel.isActive && (
                      <div className="flex items-center justify-end gap-2 mt-3">
                        <a
                          href={`tel:${hotel.phone}`}
                          className="size-12 flex items-center justify-center rounded-full border border-[#F3F3F3] bg-transparent shrink-0 text-black group-hover:border-[#E8E8E8] group-hover:shadow-md group-data-[selected=true]:border-[#E8E8E8] group-data-[selected=true]:shadow-md transition duration-300"
                          onClick={(event) => {
                            event.stopPropagation();
                            fireTagManagerEvent("call_hotel", {
                              destination: !!searchParameters?.destinationLabel
                                ? searchParameters.destinationLabel
                                : null,
                              is_price_loading: !hotel.availability,
                              amount: hotel.availability
                                ? Number(
                                    hotel.availability.availabilityInfo.value.toFixed(
                                      0,
                                    ),
                                  )
                                : 0,
                              collection_id: hotel._id,
                              collection_name: hotel.name,
                              is_available:
                                hotel.availability &&
                                hotel.availability.availabilityInfo.available,
                              is_free: !hotel.isActive,
                              is_loyalty_enabled:
                                !!hotel.isLoyaltyEnabled &&
                                !!hotel?.isLoyaltyEnabledAdmin,
                              list_position: null,
                              source: "Details",
                              user_id: user?._id ?? null,
                              stars:
                                hotel.stars && Number(hotel.stars) !== 0
                                  ? Number(hotel.stars)
                                  : null,
                              tag: !!searchParameters?.tag
                                ? searchParameters.tag
                                : null,
                              adults: searchParameters?.adults ?? null,
                              children: searchParameters?.childrenAge.length,
                              sort_type: searchParameters?.sortBy
                                ? ANALYTICS_SORT_BY[
                                    (
                                      {
                                        recommended: "RECOMMENDED",
                                        distance_to_cc: "DISTANCE",
                                        reviews_score: "REVIEWS",
                                        price: "PRICE",
                                      } as const
                                    )[searchParameters.sortBy]
                                  ]
                                : ANALYTICS_SORT_BY.RECOMMENDED,
                              categories_filter: JSON.stringify(
                                searchParameters?.filters ?? {},
                              ),
                              check_in: searchParameters?.arrivalDate
                                ? format(
                                    new Date(searchParameters.arrivalDate),
                                    "dd-MM-yyyy",
                                    {
                                      locale: it,
                                    },
                                  )
                                : null,
                              check_out: searchParameters?.departureDate
                                ? format(
                                    new Date(searchParameters.departureDate),
                                    "dd-MM-yyyy",
                                    {
                                      locale: it,
                                    },
                                  )
                                : null,
                              includes_benefits:
                                hotel?.advantagesOnDirectWebsite?.length > 0,
                            });

                            if (!isMobile) {
                              event.preventDefault();
                              openModal(
                                {
                                  content: (
                                    <div className="flex flex-col p-8 items-center justify-center gap-4 flex-1">
                                      <button
                                        type="button"
                                        onClick={closeModal}
                                        className="bg-transparent border-none touch-hitbox absolute top-4 right-4"
                                      >
                                        <IconNew
                                          icon="close"
                                          className="size-5"
                                        />
                                      </button>
                                      <img
                                        src={imageBadgePhoneNumber}
                                        role="presentation"
                                        className="size-24 shrink-0 mx-auto"
                                      />
                                      <div className="flex flex-col gap-1">
                                        <h3 className="font-medium text-[#747474] text-center mb-0 text-base">
                                          {t("ds.call_structure", {
                                            name: hotel.name,
                                          })}
                                        </h3>
                                        <p className="text-lg font-medium text-black text-center">
                                          {hotel.phone}
                                        </p>
                                      </div>
                                      <div className="flex items-center">
                                        <button
                                          type="button"
                                          className="flex items-center gap-1 bg-transparent border-none text-[#A2A2A2] flex-1"
                                          onClick={() => {
                                            copyToClipboard(hotel.phone);
                                            toast.success(
                                              t("ds.phone_number_copied"),
                                            );
                                          }}
                                        >
                                          <IconCopy className="size-4" />
                                          <p className="text-xs font-medium">
                                            {t("ds.copy")}
                                          </p>
                                        </button>
                                      </div>
                                      {isExtraDiscountApplied && (
                                        <p className="text-sm font-medium text-center mt-8 text-[#747474] flex flex-wrap items-center gap-1 justify-center">
                                          <span>
                                            {t("ds.dont_forget_discount.0")}
                                          </span>
                                          <span className="text-black">
                                            {t("ds.dont_forget_discount.1", {
                                              discountCode: "TAKYON",
                                            })}
                                          </span>
                                          <span>
                                            {t("ds.dont_forget_discount.2")}
                                          </span>
                                          <span className="text-black">
                                            {t("ds.dont_forget_discount.3", {
                                              percentage:
                                                hotel.loyatyDiscountPercentage,
                                            })}
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  ),
                                  className:
                                    "rounded-t-3xl h-fit self-end lg:h-auto lg:self-center lg:rounded-3xl lg:max-w-lg",
                                },
                                {
                                  hideModalCloseBtn: true,
                                },
                              );
                            }
                          }}
                        >
                          <IconTelephone className="size-4" />
                        </a>
                        <button
                          type="button"
                          className="px-5 py-3.5 bg-[#8CE786] font-medium text-sm group-hover:shadow-md group-data-[selected=true]:shadow-md group-hover:ring-1 group-data-[selected=true]:ring-1 group-hover:ring-[#85DB7F] group-data-[selected=true]:ring-[#85DB7F] transition duration-300 rounded-2xl flex items-center justify-center border-0 gap-2 hover:bg-[#85DB7F]"
                          onClick={(e) => {
                            e.stopPropagation();
                            CollectionController.clickOnCollection(hotel._id, {
                              btn: "visit_website",
                              directPrice:
                                hotel.availability?.availabilityInfo.value,
                              cutPrice: undefined,
                              bookingPrice: undefined,
                              hotelsPrice: "N/A",
                              bookingComId: hotel.bookingId,
                              checkin: searchParameters?.arrivalDate,
                              checkout: searchParameters?.departureDate,
                            });
                            const newTabUrl = buildRedirectURL(
                              hotel._id,
                              fallbackUrl,
                            );
                            fireTagManagerEvent("book_on_site", {
                              destination: !!searchParameters?.destinationLabel
                                ? searchParameters.destinationLabel
                                : null,
                              is_price_loading: !hotel.availability,
                              amount: hotel.availability
                                ? Number(
                                    hotel.availability.availabilityInfo.value.toFixed(
                                      0,
                                    ),
                                  )
                                : 0,
                              collection_id: hotel._id,
                              collection_name: hotel.name,
                              is_available:
                                hotel.availability &&
                                hotel.availability.availabilityInfo.available,
                              is_free: !hotel.isActive,
                              is_loyalty_enabled:
                                !!hotel.isLoyaltyEnabled &&
                                !!hotel?.isLoyaltyEnabledAdmin,
                              list_position: null,
                              user_id: user?._id ?? null,
                              stars:
                                hotel.stars && Number(hotel.stars) !== 0
                                  ? Number(hotel.stars)
                                  : null,
                              tag: !!searchParameters?.tag
                                ? searchParameters.tag
                                : null,
                              adults: searchParameters?.adults ?? null,
                              children: searchParameters?.childrenAge.length,
                              sort_type: searchParameters?.sortBy
                                ? ANALYTICS_SORT_BY[
                                    (
                                      {
                                        recommended: "RECOMMENDED",
                                        distance_to_cc: "DISTANCE",
                                        reviews_score: "REVIEWS",
                                        price: "PRICE",
                                      } as const
                                    )[searchParameters.sortBy]
                                  ]
                                : ANALYTICS_SORT_BY.RECOMMENDED,
                              categories_filter: JSON.stringify(
                                searchParameters?.filters ?? {},
                              ),
                              check_in: searchParameters?.arrivalDate
                                ? format(
                                    new Date(searchParameters.arrivalDate),
                                    "dd-MM-yyyy",
                                    {
                                      locale: it,
                                    },
                                  )
                                : null,
                              check_out: searchParameters?.departureDate
                                ? format(
                                    new Date(searchParameters.departureDate),
                                    "dd-MM-yyyy",
                                    {
                                      locale: it,
                                    },
                                  )
                                : null,
                              includes_benefits:
                                hotel?.advantagesOnDirectWebsite?.length > 0,
                            });
                            window.open(newTabUrl, "_blank");
                          }}
                          disabled={
                            !hotel.availability ||
                            !hotel.availability.availabilityInfo.available
                          }
                        >
                          {t("ds.view_offer")}
                          <IconChevron className="size-3 rotate-180" />
                        </button>
                      </div>
                    )}
                    <div
                      className={cn(
                        "flex flex-col w-fit ml-auto mt-3",
                        isExtraDiscountApplied &&
                          hotel.isActive &&
                          "bg-black rounded-[14px] p-[2px]",
                      )}
                    >
                      <p
                        className={cn(
                          "rounded-full px-2 py-1 gap-1 text-xs flex items-center justify-center text-center duration-300 transition ring-1",
                          hotel.isActive &&
                            "bg-[#E8FAE7] text-[#619F5D] ring-[#D6F6D4]",
                          !hotel.isActive &&
                            "bg-[#F8F8F8] group-hover:bg-[#E8E8E8] group-data-[selected=true]:bg-[#E8E8E8] text-[#747474] ring-[#F3F3F3] group-hover:ring-[#D1D1D1] group-data-[selected=true]:ring-[#D1D1D1]",
                        )}
                      >
                        {hotel.isActive && (
                          <IconVerifiedBadge className="size-3.5 shrink-0" />
                        )}
                        {!hotel.isActive && (
                          <IconWebsite className="size-3.5 shrink-0" />
                        )}
                        <span className="flex items-center min-w-0 gap-1">
                          <span className="font-medium shrink-0">
                            {hotel.isActive
                              ? `${t("ds.verified_website")}`
                              : `${t("ds.official_website")}`}
                          </span>
                          {hotel.website && (
                            <>
                              <span className="shrink-0">|</span>
                              <span className="min-w-0 truncate">
                                {getWebsiteDomainAndPath(hotel.website)}
                              </span>
                            </>
                          )}
                        </span>
                      </p>
                      {isExtraDiscountApplied && hotel.isActive && (
                        <div className="flex items-center justify-center py-0.5">
                          <p className="text-xs text-white">
                            {t("ds.loyalty_discount_with_code", {
                              percentage: hotel?.loyatyDiscountPercentage,
                            })}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </motion.button>
        );
      }

      return (
        <motion.button
          onMouseEnter={() => {
            onSelect(hotel._id);
          }}
          onMouseLeave={() => {
            onSelect("");
          }}
          onClick={(e) => {
            e.stopPropagation();
            CollectionController.clickOnCollection(hotel._id, {
              btn: "detail_page",
              directPrice: hotel.availability?.availabilityInfo.value,
              cutPrice: undefined,
              bookingPrice: undefined,
              hotelsPrice: "N/A",
              bookingComId: hotel.bookingId,
              checkin: searchParameters.arrivalDate,
              checkout: searchParameters.departureDate,
            });
            fireTagManagerEvent("open_modal", {
              user_id: user?._id ?? null,
              collection_id: hotel._id,
              collection_name: hotel.name,
              is_available:
                hotel.availability &&
                hotel.availability.availabilityInfo.available,
              is_free: !hotel.isActive,
              is_loyalty_enabled:
                !!hotel.isLoyaltyEnabled && !!hotel?.isLoyaltyEnabledAdmin,
              list_position: listPosition !== -1 ? listPosition : null,
              source: ANALYTICS_SOURCE.LIST,
              stars:
                hotel.stars && Number(hotel.stars) !== 0
                  ? Number(hotel.stars)
                  : null,
              destination: !!searchParameters.destinationLabel
                ? searchParameters.destinationLabel
                : null,
              tag: !!searchParameters.tag ? searchParameters.tag : null,
              includes_benefits: hotel?.advantagesOnDirectWebsite?.length > 0,
            });
            setCurrentSelected(hotel._id);
            onCardClick(hotel);
          }}
          id={hotel._id}
          data-hotel-id={hotel._id}
          data-collection-id={hotel._id}
          data-booking-id={hotel.bookingId}
          title={hotel.name}
          type="button"
          className="hotel-result px-4 border-none group bg-transparent"
        >
          <div className="flex flex-col gap-2 p-1">
            <div className="relative rounded-2xl w-full h-[17.313rem] border-none box-border bg-[#4b4848] ring-4 ring-white shadow-xl overflow-hidden shrink-0 transition duration-300">
              <Carousel
                setApi={setCarouselApi}
                className="size-full [&>div]:size-full"
              >
                <CarouselContent className="size-full ml-0">
                  {images.slice(0, 8).map((url, index) => (
                    <CarouselItem
                      key={`hotel-img-${index}-${hotel._id}`}
                      className="size-full pl-0 relative"
                    >
                      <ImageWithFallback
                        src={url.replace("square60", "square600")}
                        alt={`${hotel.name} - ${index + 1}`}
                        className="size-full object-cover"
                      />
                      {index === Math.min(images.length, 8) - 1 ? (
                        <button
                          className="border-none absolute size-full flex justify-center items-center top-0 left-0 bg-black bg-opacity-40"
                          onClick={(e) => {
                            e.stopPropagation();
                            openModal({
                              content: (
                                <div className="flex flex-col">
                                  <div className="relative flex justify-end px-3 items-center box-border border-bottom h-12">
                                    <h3 className="text-sm font-medium text-center mb-0 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
                                      {`${t("ds.photos")} (${images.length})`}
                                    </h3>
                                    <button
                                      type="button"
                                      onClick={closeModal}
                                      className="bg-transparent border-none touch-hitbox relative"
                                    >
                                      <IconNew
                                        icon="close"
                                        className="size-5"
                                      />
                                    </button>
                                  </div>
                                  <div className="overflow-y-auto h-[calc(100dvh-3rem)] px-4 py-3 grid grid-cols-2 gap-4">
                                    {images.map((url, index) => (
                                      <button
                                        type="button"
                                        key={`gallery-img-${index}-${hotel._id}`}
                                        className="bg-transparent border-none"
                                        onClick={() => {
                                          openFullScreenCarousel(index);
                                        }}
                                      >
                                        <ImageWithFallback
                                          src={url.replace(
                                            "square60",
                                            "square600",
                                          )}
                                          alt={`${hotel.name} - ${index + 1}`}
                                          className="w-full object-cover rounded-lg"
                                          style={{
                                            aspectRatio: "1 / 0.8",
                                          }}
                                        />
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              ),
                              className:
                                "rounded-t-3xl self-end h-[calc(100dvh-1rem)]",
                            });
                          }}
                        >
                          <div className="bg-transparent rounded-xl px-3 py-1 border border-white text-white text-sm font-medium">
                            {t("ds.see_more_photo")}
                          </div>
                        </button>
                      ) : null}
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
              </Carousel>
              <div className="absolute left-1/2 -translate-x-1/2 bottom-4 flex items-center gap-1">
                {carouselSlidesCount > 0 &&
                  Array.from({ length: carouselSlidesCount }).map(
                    (_, index) => (
                      <div
                        key={index}
                        className={`size-2 rounded-full ${
                          carouselCurrentSlide === index
                            ? "bg-white"
                            : "bg-white/50"
                        }`}
                      />
                    ),
                  )}
              </div>
              {hotel.isActive && (
                <button
                  className="absolute border-none top-2.5 left-2.5 items-center gap-2 bg-white shadow-[0px_0px_20px_5px_rgba(0,_0,_0,_0.25)] rounded-full pl-[0.375rem] pr-3 h-8 flex"
                  onClick={(e) => {
                    e.stopPropagation();
                    openPlusModal();
                  }}
                >
                  <img
                    src={imageBadgePlus}
                    role="presentation"
                    className="size-5 shrink-0"
                    alt=""
                  />
                  <p className="text-sm text-black">{t("ds.booking_plus")}</p>
                </button>
              )}
            </div>
            <main className="flex flex-col w-full">
              <div className="flex flex-start justify-between gap-4 pt-2">
                <h3 className="text-lg font-medium mb-0 text-left line-clamp-2 text-black">
                  {hotel.name}
                </h3>
                {!!hotel.reviewScore && !!hotel.reviewCount && (
                  <p className="text-sm flex items-center gap-0.5 h-fit translate-y-1.5 text-black">
                    <IconStar className="size-3" />
                    <span>{hotel.reviewScore}</span>
                    <span className="text-[#747474]">
                      {`(${new Intl.NumberFormat(
                        searchParameters.language ?? "en-US",
                      ).format(hotel.reviewCount)})`}
                    </span>
                  </p>
                )}
              </div>
              <p className="text-sm text-[#747474] gap-1 flex items-center mt-1 line-clamp-1">
                {hotel.stars && Number(hotel.stars) !== 0 && (
                  <span>
                    {`Hotel ${hotel.stars} ${t("ds.star", {
                      count: Number(hotel.stars),
                    })} |`}
                  </span>
                )}
                <span>{hotel.city}</span>
              </p>
              {hotel.isActive &&
                !!highlightedAdvantage &&
                highlightedAdvantageLabel && (
                  <div className="flex items-center gap-2 shrink-0 mt-1.5">
                    {HighlightedAdvantageIcon && (
                      <HighlightedAdvantageIcon className="size-3.5 text-[#747474]" />
                    )}
                    <span className="text-sm text-[#747474]">
                      {t(highlightedAdvantageLabel)}
                    </span>
                  </div>
                )}
              <div className="flex items-center gap-1 mt-2.5">
                <div className="flex-1 h-px bg-[#E8E8E8]" />
                <div
                  className={cn(
                    "flex flex-col w-fit",
                    isExtraDiscountApplied &&
                      hotel.isActive &&
                      "bg-black rounded-[14px] p-[2px]",
                  )}
                >
                  <div
                    className={cn(
                      "rounded-full px-2 py-1 gap-1 text-xs flex items-center justify-center tex-center ring-1 transition duration-300",
                      hotel.isActive &&
                        "bg-[#E8FAE7] text-[#619F5D] ring-[#D6F6D4]",
                      !hotel.isActive &&
                        "bg-[#F8F8F8] group-hover:bg-[#E8E8E8] group-data-[selected=true]:bg-[#E8E8E8] text-[#747474] ring-[#F3F3F3] group-hover:ring-[#D1D1D1] group-data-[selected=true]:ring-[#D1D1D1]",
                    )}
                  >
                    {hotel.isActive && (
                      <IconVerifiedBadge className="size-3.5" />
                    )}
                    {!hotel.isActive && <IconWebsite className="size-3.5" />}
                    <span className="font-medium">
                      {hotel.isActive
                        ? `${t("ds.verified_website")}`
                        : `${t("ds.official_website")}`}
                    </span>
                    {hotel.website && (
                      <>
                        <span>|</span>
                        <span>{getWebsiteDomainAndPath(hotel.website)}</span>
                      </>
                    )}
                  </div>
                  {isExtraDiscountApplied && hotel.isActive && (
                    <div className="flex items-center justify-center py-0.5">
                      <p className="text-xs text-white">
                        {t("ds.loyalty_discount_with_code", {
                          percentage: hotel?.loyatyDiscountPercentage,
                        })}
                      </p>
                    </div>
                  )}
                </div>
                <div className="flex-1 h-px bg-[#E8E8E8]" />
              </div>
              <div className="flex items-center mt-2.5 gap-2">
                {hotel.availability &&
                hotel.availability.availabilityInfo.available ? (
                  <div className="flex flex-1 items-center flex-col">
                    <div className="flex justify-between items-end gap-1">
                      <p className="text-xs text-black">{t("ds.from2")}</p>
                      <p className="font-medium text-2xl translate-y-1 text-black">
                        {getDisplayPrice({
                          availability: hotel.availability,
                          deltaBooking: hotel.deltaPriceBookingCom,
                          deltaHotels: hotel.deltaPriceHotelsCom,
                          lang: searchParameters.language,
                        })}
                      </p>
                    </div>
                    {hotel.availability.availabilityInfo.available ? (
                      <div className="flex items-center justify-center w-full">
                        <p className="text-xs text-[#EF4444] font-medium text-center">
                          {getOTADeltaPrice({
                            availability: hotel.availability,
                            deltaBooking: hotel.deltaPriceBookingCom,
                            deltaHotels: hotel.deltaPriceHotelsCom,
                            lang: searchParameters.language,
                          })}
                        </p>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="flex rounded-lg px-2 py-1 justify-center items-center bg-[#E8E8E8] mt-2">
                    <p className="text-xs text-[#747474]">
                      {t("ds.no_availability")}
                    </p>
                  </div>
                )}
                {hotel.isActive && (
                  <>
                    <a
                      href={`tel:${hotel.phone}`}
                      className="size-12 flex items-center justify-center rounded-full border border-[#E8E8E8] bg-transparent shrink-0 text-black"
                      onClick={(event) => {
                        event.stopPropagation();
                        fireTagManagerEvent("call_hotel", {
                          destination: !!searchParameters?.destinationLabel
                            ? searchParameters.destinationLabel
                            : null,
                          is_price_loading: !hotel.availability,
                          amount: hotel.availability
                            ? Number(
                                hotel.availability.availabilityInfo.value.toFixed(
                                  0,
                                ),
                              )
                            : 0,
                          collection_id: hotel._id,
                          collection_name: hotel.name,
                          is_available:
                            hotel.availability &&
                            hotel.availability.availabilityInfo.available,
                          is_free: !hotel.isActive,
                          is_loyalty_enabled:
                            !!hotel.isLoyaltyEnabled &&
                            !!hotel?.isLoyaltyEnabledAdmin,
                          list_position: null,
                          source: "Details",
                          user_id: user?._id ?? null,
                          stars:
                            hotel.stars && Number(hotel.stars) !== 0
                              ? Number(hotel.stars)
                              : null,
                          tag: !!searchParameters?.tag
                            ? searchParameters.tag
                            : null,
                          adults: searchParameters?.adults ?? null,
                          children: searchParameters?.childrenAge.length,
                          sort_type: searchParameters?.sortBy
                            ? ANALYTICS_SORT_BY[
                                (
                                  {
                                    recommended: "RECOMMENDED",
                                    distance_to_cc: "DISTANCE",
                                    reviews_score: "REVIEWS",
                                    price: "PRICE",
                                  } as const
                                )[searchParameters.sortBy]
                              ]
                            : ANALYTICS_SORT_BY.RECOMMENDED,
                          categories_filter: JSON.stringify(
                            searchParameters?.filters ?? {},
                          ),
                          check_in: searchParameters?.arrivalDate
                            ? format(
                                new Date(searchParameters.arrivalDate),
                                "dd-MM-yyyy",
                                {
                                  locale: it,
                                },
                              )
                            : null,
                          check_out: searchParameters?.departureDate
                            ? format(
                                new Date(searchParameters.departureDate),
                                "dd-MM-yyyy",
                                {
                                  locale: it,
                                },
                              )
                            : null,
                          includes_benefits:
                            hotel?.advantagesOnDirectWebsite?.length > 0,
                        });

                        if (!isMobile) {
                          event.preventDefault();
                          openModal(
                            {
                              content: (
                                <div className="flex flex-col p-8 items-center justify-center gap-4 flex-1">
                                  <button
                                    type="button"
                                    onClick={closeModal}
                                    className="bg-transparent border-none touch-hitbox absolute top-4 right-4"
                                  >
                                    <IconNew icon="close" className="size-5" />
                                  </button>
                                  <img
                                    src={imageBadgePhoneNumber}
                                    role="presentation"
                                    className="size-24 shrink-0 mx-auto"
                                  />
                                  <div className="flex flex-col gap-1">
                                    <h3 className="font-medium text-[#747474] text-center mb-0 text-base">
                                      {t("ds.call_structure", {
                                        name: hotel.name,
                                      })}
                                    </h3>
                                    <p className="text-lg font-medium text-black text-center">
                                      {hotel.phone}
                                    </p>
                                  </div>
                                  <div className="flex items-center">
                                    <button
                                      type="button"
                                      className="flex items-center gap-1 bg-transparent border-none text-[#A2A2A2] flex-1"
                                      onClick={() => {
                                        copyToClipboard(hotel.phone);
                                        toast.success(
                                          t("ds.phone_number_copied"),
                                        );
                                      }}
                                    >
                                      <IconCopy className="size-4" />
                                      <p className="text-xs font-medium">
                                        {t("ds.copy")}
                                      </p>
                                    </button>
                                  </div>
                                  {isExtraDiscountApplied && (
                                    <p className="text-sm font-medium text-center mt-8 text-[#747474] flex flex-wrap items-center gap-1 justify-center">
                                      <span>
                                        {t("ds.dont_forget_discount.0")}
                                      </span>
                                      <span className="text-black">
                                        {t("ds.dont_forget_discount.1", {
                                          discountCode: "TAKYON",
                                        })}
                                      </span>
                                      <span>
                                        {t("ds.dont_forget_discount.2")}
                                      </span>
                                      <span className="text-black">
                                        {t("ds.dont_forget_discount.3", {
                                          percentage:
                                            hotel.loyatyDiscountPercentage,
                                        })}
                                      </span>
                                    </p>
                                  )}
                                </div>
                              ),
                              className:
                                "rounded-t-3xl h-fit self-end lg:h-auto lg:self-center lg:rounded-3xl lg:max-w-lg",
                            },
                            {
                              hideModalCloseBtn: true,
                            },
                          );
                        }
                      }}
                    >
                      <IconTelephone className="size-4" />
                    </a>
                    <div className="flex items-center gap-2">
                      <Button
                        size="sm"
                        className="h-12 text-sm font-medium rounded-2xl gap-1 pl-4 pr-2.5"
                        text={t("ds.view_offer")}
                        onClick={(e) => {
                          e.stopPropagation();
                          CollectionController.clickOnCollection(hotel._id, {
                            btn: "visit_website",
                            directPrice:
                              hotel.availability?.availabilityInfo.value,
                            cutPrice: undefined,
                            bookingPrice: undefined,
                            hotelsPrice: "N/A",
                            bookingComId: hotel.bookingId,
                            checkin: searchParameters?.arrivalDate,
                            checkout: searchParameters?.departureDate,
                          });
                          const newTabUrl = buildRedirectURL(
                            hotel._id,
                            fallbackUrl,
                          );
                          fireTagManagerEvent("book_on_site", {
                            destination: !!searchParameters?.destinationLabel
                              ? searchParameters.destinationLabel
                              : null,
                            is_price_loading: !hotel.availability,
                            amount: hotel.availability
                              ? Number(
                                  hotel.availability.availabilityInfo.value.toFixed(
                                    0,
                                  ),
                                )
                              : 0,
                            collection_id: hotel._id,
                            collection_name: hotel.name,
                            is_available:
                              hotel.availability &&
                              hotel.availability.availabilityInfo.available,
                            is_free: !hotel.isActive,
                            is_loyalty_enabled:
                              !!hotel.isLoyaltyEnabled &&
                              !!hotel?.isLoyaltyEnabledAdmin,
                            list_position: null,
                            user_id: user?._id ?? null,
                            stars:
                              hotel.stars && Number(hotel.stars) !== 0
                                ? Number(hotel.stars)
                                : null,
                            tag: !!searchParameters?.tag
                              ? searchParameters.tag
                              : null,
                            adults: searchParameters?.adults ?? null,
                            children: searchParameters?.childrenAge.length,
                            sort_type: searchParameters?.sortBy
                              ? ANALYTICS_SORT_BY[
                                  (
                                    {
                                      recommended: "RECOMMENDED",
                                      distance_to_cc: "DISTANCE",
                                      reviews_score: "REVIEWS",
                                      price: "PRICE",
                                    } as const
                                  )[searchParameters.sortBy]
                                ]
                              : ANALYTICS_SORT_BY.RECOMMENDED,
                            categories_filter: JSON.stringify(
                              searchParameters?.filters ?? {},
                            ),
                            check_in: searchParameters?.arrivalDate
                              ? format(
                                  new Date(searchParameters.arrivalDate),
                                  "dd-MM-yyyy",
                                  {
                                    locale: it,
                                  },
                                )
                              : null,
                            check_out: searchParameters?.departureDate
                              ? format(
                                  new Date(searchParameters.departureDate),
                                  "dd-MM-yyyy",
                                  {
                                    locale: it,
                                  },
                                )
                              : null,
                            includes_benefits:
                              hotel?.advantagesOnDirectWebsite?.length > 0,
                          });
                          window.open(newTabUrl, "_blank");
                        }}
                        disabled={
                          !hotel.availability ||
                          !hotel.availability.availabilityInfo.available
                        }
                        icon="chevron_right"
                        iconClass="size-5"
                        textLeft
                      />
                    </div>
                  </>
                )}
              </div>
            </main>
          </div>
        </motion.button>
      );
    },
  ),
);

export const Reviews = memo(
  ({
    hotel,
    from,
    hideHeader,
  }: {
    hotel: HotelDetails;
    from?: string;
    hideHeader?: boolean;
  }) => {
    const { t, i18n } = useTranslation();

    const { searchParameters } = useSearch();

    const [reviewsSort, setReviewsSort] = useState<
      "most_relevant" | "most_recent" | "highest_rating" | "lowest_rating"
    >("most_relevant");

    const uniqueReviews = useMemo(() => {
      const reviews = hotel.reviewData?.reviews || [];

      const unique: any[] = Array.from(
        Object.values(
          reviews.reduce((acc: any, review: any) => {
            const id = review.review_id;

            if (!acc[id]) {
              acc[id] = review;
              return acc;
            }

            const current = acc[id];
            const langs = [i18n.language, "en-gb", "en-us"];

            const currentPriority = langs.indexOf(current.language_code);
            const newPriority = langs.indexOf(review.languagecode);

            if (
              newPriority !== -1 &&
              (currentPriority === -1 || newPriority < currentPriority)
            ) {
              acc[id] = review;
            }

            return acc;
          }, {}),
        ),
      );

      const timestamps = unique.map((r) => new Date(r.date).getTime());
      const minDate = Math.min(...timestamps);
      const maxDate = Math.max(...timestamps);

      const avgRating = hotel.reviewData?.reviewScore ?? 0;

      if (reviewsSort === "most_relevant") {
        const ratingDiffs = unique.map((r) =>
          Math.abs(r.average_score - avgRating),
        );
        const maxDiff = Math.max(...ratingDiffs) || 1;

        return unique
          .map((r) => {
            const time = new Date(r.date).getTime();

            const recencyScore = (time - minDate) / (maxDate - minDate || 1);

            const diff = Math.abs(r.average_score - avgRating);
            const closenessScore = 1 - diff / maxDiff;

            const weightedScore = 0.5 * recencyScore + 0.5 * closenessScore;

            return { ...r, weightedScore };
          })
          .sort((a, b) => b.weightedScore - a.weightedScore);
      }

      return unique.sort((a, b) => {
        if (reviewsSort === "most_recent") {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        }

        if (reviewsSort === "highest_rating") {
          return b.average_score - a.average_score;
        }

        if (reviewsSort === "lowest_rating") {
          return a.average_score - b.average_score;
        }

        return 0;
      });
    }, [hotel.reviewData?.reviews, reviewsSort, i18n.language]);

    return (
      <div>
        {!hideHeader && (
          <div className="d-flex justify-content-center p-2 border-bottom">
            <p className="fs-body-sm medium m-0">{t("ds.reviews_title")}</p>
            <div className="position-absolute" style={{ right: "10px" }}>
              <IconNew icon="close" fill={false} hasFill color="black" />
            </div>
          </div>
        )}
        <div className="flex flex-col gap-5 py-3">
          {!!hotel.reviewData?.reviewScore &&
            !!hotel.reviewData?.reviewCount && (
              <div className="flex flex-col items-center gap-1">
                <div className="flex items-center gap-1 bg-black py- px-3 rounded-full">
                  <p
                    className="py-1.5 px-1 medium review-score text-white"
                    style={{ marginLeft: "8px" }}
                  >
                    {hotel.reviewData.reviewScore}
                  </p>
                </div>
                <p className="text-base font-medium review-summary">
                  {t(
                    `ds.rating_${
                      hotel.reviewData.reviewScore.toString().split(".")[0]
                    }`,
                  )}
                </p>
                <p className="text-xs text-gray-400">
                  {`${new Intl.NumberFormat(
                    searchParameters?.language ?? "en-US",
                  ).format(hotel.reviewData?.reviewCount)} ${t(
                    "ds.total_reviews",
                    {
                      count: hotel.reviewData?.reviewCount,
                    },
                  )}`}
                </p>
              </div>
            )}
          {!(
            !!hotel.reviewData?.reviewScore && !!hotel.reviewData?.reviewCount
          ) && (
            <p className="text-sm font-medium text-[#747474] text-left flex items-center gap-1">
              {t("ds.no_reviews_yet")}
            </p>
          )}
        </div>
        <div className="flex justify-between items-center mt-4">
          <span className="text-xs font-medium text-[#A2A2A2]">{`${new Intl.NumberFormat(
            searchParameters.language ?? "en-US",
          ).format(uniqueReviews?.length ?? 0)} ${t("ds.available_reviews", {
            count: uniqueReviews?.length ?? 0,
          })}`}</span>
          <div className="max-w-60">
            <Select
              value={reviewsSort}
              onChange={(e) => {
                setReviewsSort(
                  e.target.value as
                    | "most_recent"
                    | "highest_rating"
                    | "lowest_rating",
                );
              }}
              options={[
                {
                  value: "most_relevant",
                  text: t("ds.reviews_filters.most_relevant"),
                },
                {
                  value: "most_recent",
                  text: t("ds.reviews_filters.most_recent"),
                },
                {
                  value: "highest_rating",
                  text: t("ds.reviews_filters.highest_rating"),
                },
                {
                  value: "lowest_rating",
                  text: t("ds.reviews_filters.lowest_rating"),
                },
              ]}
            />
          </div>
        </div>
        <div className="horizontal-divider" />
        <div className="flex flex-col">
          {uniqueReviews?.map((review, index) => {
            const title = review.title_translated
              ? review.title_translated
              : review.title;
            const pros = review.pros_translated
              ? review.pros_translated
              : review.pros;
            const cons = review.cons_translated
              ? review.cons_translated
              : review.cons;

            return (
              <Fragment key={index}>
                <article className="flex flex-col gap-4">
                  <header className="flex gap-2">
                    <div className="rounded-full flex items-center justify-center bg-[#F8F8F8] px-4 py-1">
                      {Math.min(review.average_score * 2.5, 10).toFixed(0)}
                    </div>
                    <div className="flex flex-col justify-center">
                      <h4 className="text-sm font-medium mb-0">
                        {review.author.name}
                      </h4>
                      <p className="text-xs font-medium text-[#747474]">
                        {t(
                          `ds.country_codes_nations.${review.author.countrycode.toUpperCase()}`,
                        )}
                      </p>
                    </div>
                    <p className="text-xs font-medium text-[#A2A2A2] ml-auto">
                      {format(new Date(review.date), "d MMMM yyyy", {
                        locale:
                          {
                            en: enUS,
                            it: it,
                            es: es,
                          }[i18n.language] ?? enUS,
                      })}
                    </p>
                  </header>
                  <main className="flex flex-col gap-4">
                    <p className="text-sm font-medium">
                      {title !== "" ? title : t("ds.nothing")}
                    </p>
                    <div className="flex gap-4">
                      <IconThumbsUp className="size-4 shrink-0" />
                      <p className="text-xs font-medium">
                        {pros !== "" ? pros : t("ds.nothing")}
                      </p>
                    </div>
                    <div className="flex gap-4">
                      <IconThumbsDown className="size-4 shrink-0" />
                      <p className="text-xs font-medium">
                        {cons !== "" ? cons : t("ds.nothing")}
                      </p>
                    </div>
                  </main>
                </article>
                {index !== (uniqueReviews?.length ?? 0) - 1 && (
                  <div className="horizontal-divider" />
                )}
              </Fragment>
            );
          })}
        </div>
      </div>
    );
  },
);

type SearchDrawerProps = {
  isSearchDrawerOpen: boolean;
  setIsSearchDrawerOpen: Dispatch<SetStateAction<boolean>>;
  locale: Locale | undefined;
};

const SearchDrawer: FC<SearchDrawerProps> = ({
  isSearchDrawerOpen,
  setIsSearchDrawerOpen,
  locale,
}) => {
  const { t } = useTranslation();

  const { searchParameters, goToSearchUrl, setParameters } = useSearch();

  const [urlParams] = useSearchParams();

  const isSmallScreen = useMediaQuery({ query: SMALL_SCREEN });

  const [isDestinationModalOpen, setIsDestinationModalOpen] = useState(false);
  const [isDatesModalOpen, setIsDatesModalOpen] = useState(false);
  const [isGuestsModalOpen, setIsGuestsModalOpen] = useState(false);

  const guestsRef = useRef<HTMLDivElement>(null);
  const locationRef = useRef<HTMLDivElement>(null);
  const calendarRef = useRef<HTMLDivElement>(null);

  const [destinationInputText, setDestinationInputText] = useState("");
  const [destinationIsLoading, setDestinationIsLoading] = useState(false);
  const [locations, setLocations] = useState<AutocompleteLocation[]>([]);

  const [range, setRange] = useState<Range>({
    startDate: searchParameters?.arrivalDate
      ? new Date(searchParameters?.arrivalDate)
      : new Date(),
    endDate: searchParameters?.departureDate
      ? new Date(searchParameters?.departureDate)
      : addDays(new Date(), 1),
    key: "selection",
  });

  const searchLocation = async (query: string) => {
    setDestinationIsLoading(true);
    try {
      const data = await autocomplete(query);
      setLocations(data);
    } catch (error) {
      console.log(error);
    }
    setDestinationIsLoading(false);
  };

  const searchCallbackDebounced = useRef(debounce(searchLocation, 1000));

  const locationsPerCategory = useMemo(() => {
    return locations.reduce(
      (acc, location) => {
        if (location.placeId) {
          if (location.nearby || location.extra) {
            acc["extended"].push(location);
            return acc;
          }

          acc["places"].push(location);
          return acc;
        }

        acc["structures"].push(location);
        return acc;
      },
      {
        places: [] as AutocompleteLocation[],
        structures: [] as AutocompleteLocation[],
        extended: [] as AutocompleteLocation[],
      },
    );
  }, [locations]);

  const searchParametersState = useMemo(
    () => ({
      destinationLabel: searchParameters.destinationLabel,
      tag: searchParameters.tag,
      arrivalDate: searchParameters.arrivalDate,
      departureDate: searchParameters.departureDate,
      adults: searchParameters.adults,
      childrenAge: searchParameters.childrenAge,
    }),
    [searchParameters],
  );

  const searchParametersFromUrl = useMemo(
    () => ({
      destinationLabel:
        parseParams(
          "destinationLabel",
          urlParams.get("destinationLabel") as string,
        ) ?? undefined,
      tag: parseParams("tag", urlParams.get("tag") as string) ?? undefined,
      arrivalDate:
        parseParams("arrivalDate", urlParams.get("arrivalDate") as string) ??
        undefined,
      departureDate:
        parseParams(
          "departureDate",
          urlParams.get("departureDate") as string,
        ) ?? undefined,
      adults:
        parseParams("adults", urlParams.get("adults") as string) ?? undefined,
      childrenAge:
        parseParams("childrenAge", urlParams.get("childrenAge") as string) ??
        undefined,
    }),
    [searchParameters],
  );

  const isActionDisabled =
    (!searchParameters.destinationLabel && !searchParameters.tag) ||
    !searchParameters.arrivalDate ||
    !searchParameters.departureDate ||
    (!searchParameters.adults && !searchParameters.childrenAge);

  return (
    <>
      <AnimatePresence>
        {isSearchDrawerOpen && isSmallScreen && (
          <div className="fixed top-0 left-0 w-screen h-screen z-50">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{
                duration: 0.3,
                ease: "easeInOut",
              }}
              className="absolute top-0 left-0 size-full bg-black/50"
              onClick={() => setIsSearchDrawerOpen(false)}
            />
            <motion.div
              initial={{ y: "-100%" }}
              animate={{ y: 0 }}
              exit={{ y: "-100%" }}
              transition={{ type: "spring", damping: 40, stiffness: 300 }}
              className="absolute top-0 left-0 w-full bg-white p-4 flex flex-col gap-2"
            >
              <button
                type="button"
                className="px-4 min-h-[3.125rem] flex items-center rounded-2xl border bg-transparent border-[#E8E8E8] text-black"
                onClick={() => setIsDestinationModalOpen(true)}
              >
                <p className="text-sm font-medium">
                  {searchParameters.searchType === "tag"
                    ? t(`ds.destination_category_${searchParameters.tag}`)
                    : !!searchParameters.destinationLabel &&
                      searchParameters.destinationLabel !== ""
                    ? searchParameters.destinationLabel
                    : searchParameters.searchType === "box"
                    ? t("ds.map_area")
                    : "-"}
                </p>
              </button>
              <button
                type="button"
                className="px-4 min-h-[3.125rem] flex items-center rounded-2xl border bg-transparent border-[#E8E8E8] text-black"
                onClick={() => setIsDatesModalOpen(true)}
              >
                <p className="text-sm font-medium">
                  {`${format(
                    searchParameters.arrivalDate
                      ? new Date(searchParameters.arrivalDate)
                      : new Date(),
                    "iii dd MMM",
                    {
                      locale,
                    },
                  )} - ${format(
                    searchParameters.departureDate
                      ? new Date(searchParameters.departureDate)
                      : new Date(),
                    "iii dd MMM",
                    {
                      locale,
                    },
                  )}`}
                </p>
              </button>
              <button
                type="button"
                className="px-4 min-h-[3.125rem] flex items-center rounded-2xl border bg-transparent border-[#E8E8E8] text-black"
                onClick={() => setIsGuestsModalOpen(true)}
              >
                <p className="text-sm font-medium">
                  {searchParameters.adults ?? t("ds.guests_ph")}{" "}
                  {t("ds.adults")}{" "}
                  {searchParameters.childrenAge.length > 0 && (
                    <>
                      - {searchParameters.childrenAge.length} {t("ds.childs")}
                    </>
                  )}
                </p>
              </button>
              <Button
                text={t("ds.letsgo")}
                onClick={() => {
                  setIsSearchDrawerOpen(false);
                  goToSearchUrl(
                    {},
                    {
                      reset: true,
                      triggerTagManagerEvent: true,
                      source: ANALYTICS_SOURCE.LIST,
                    },
                  );
                }}
                disabled={
                  isActionDisabled ||
                  isEqual(searchParametersState, searchParametersFromUrl)
                }
              />
            </motion.div>
          </div>
        )}
      </AnimatePresence>
      <DestinationModal
        isLocationOpen={isDestinationModalOpen}
        setIsLocationOpen={setIsDestinationModalOpen}
        locationRef={locationRef}
        mode="mobile"
        inputText={destinationInputText}
        setInputText={setDestinationInputText}
        isLoading={destinationIsLoading}
        setIsLoading={setDestinationIsLoading}
        searchCallbackDebounced={searchCallbackDebounced}
        locations={locations}
        locationsPerCategory={locationsPerCategory}
        setIsCalendarOpen={setIsDatesModalOpen}
        setIsGuestsOpen={setIsGuestsModalOpen}
        parent="home"
      />
      <DatesModal
        isCalendarOpen={isDatesModalOpen}
        setIsCalendarOpen={setIsDatesModalOpen}
        calendarRef={calendarRef}
        mode="mobile"
        calendarLocale={locale}
        range={range}
        setRange={setRange}
        setIsLocationOpen={setIsDestinationModalOpen}
        setIsGuestsOpen={setIsGuestsModalOpen}
        parent="home"
        searchParameters={searchParameters}
        setParameters={setParameters}
      />
      <GuestsModal
        isGuestsOpen={isGuestsModalOpen}
        setIsGuestsOpen={setIsGuestsModalOpen}
        guestsRef={guestsRef}
        mode="mobile"
        setIsLocationOpen={setIsDestinationModalOpen}
        parent="nav"
      />
    </>
  );
};

export default function Results() {
  const [urlParams] = useSearchParams();
  const isSmallScreen = useMediaQuery({ query: SMALL_SCREEN });
  const isxLargeScreen = useMediaQuery({ query: x_LARGE_SCREEN });
  const isReallyLargeScreen = useMediaQuery({ query: "(min-width: 1700px)" });
  const [isMobileMinified, setIsMobileMinified] = useState(true);

  const [isSearchInViewport, setIsSearchInViewport] = useState(true);
  const [isBottomDelimiterInViewport, setIsBottomDelimiterInViewport] =
    useState(false);
  const [navbarHeight, setNavbarHeight] = useState(0);
  const [showMobileMap, setShowMobileMap] = useState(false);
  const [currIndex, setCurrIndex] = useState(-1);

  const bottomDelimiterRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();
  const {
    searchParameters,
    setParameters,
    startConnection,
    disconnectListeners,
    hotels,
    nearHotels,
    unavailableHotels,
    search,
    isLoading,
    handleSortChange,
    loadingProgress,
    allResults,
    loadMore,
    goToSearchUrl,
  } = useSearch();

  const [focussed, setFocussed] = useState("");
  const [currentSelected, setCurrentSelected] = useState("");

  const leftColumnRef = useRef<HTMLDivElement>(null);
  const useMapPosition = () => {
    const [isFixed, setIsFixed] = useState(true);
    const mapRef = useRef<HTMLDivElement>(null);

    const updatePosition = useCallback(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
          setIsFixed(!entry.isIntersecting);
        });
      },
      [],
    );

    useEffect(() => {
      const observer = new IntersectionObserver(updatePosition);

      const footer = document.querySelector("footer");
      if (footer && mapRef.current) {
        observer.observe(footer);
      }

      return () => observer.disconnect();
    }, [updatePosition]);

    return { isFixed, mapRef };
  };
  const { isFixed, mapRef } = useMapPosition();
  const [searchbarHeight, setSearchbarHeight] = useState(185);
  const [navH, setNavH] = useState(0);
  const [mapWidth, setMapWidth] = useState("50%");

  const user = useSelector(selectUser);

  const sortOptions = [
    { name: t("ds.sort_recommended"), value: SortHotelsBy.RECOMMENDED },
    { name: t("ds.sort_price"), value: SortHotelsBy.PRICE },
    { name: t("ds.sort_distance"), value: SortHotelsBy.DISTANCE_TO_CC },
    { name: t("ds.sort_review_score"), value: SortHotelsBy.REVIEWS },
  ];

  useHotelImpressions();

  useEffect(() => {
    setCurrentSelected("");
    const timer = setTimeout(() => {
      const searchbarElement = document.getElementById("searchbar");
      if (searchbarElement) {
        setSearchbarHeight(searchbarElement.offsetHeight + 85);
      }

      clearTimeout(timer);
    }, 400);

    const nav = document.querySelector("nav");
    const navH = nav?.clientHeight ?? 0;
    setNavH(navH);
  }, [searchParameters]);

  useEffect(() => {
    if (focussed) {
      const t = setTimeout(() => {
        setFocussed("");
      }, 5000);

      return () => clearTimeout(t);
    }
  }, [focussed]);

  useEffect(() => {
    if (isSmallScreen && !isMobileMinified) {
      document.querySelector("html")!.style.overflow = "hidden";
    } else {
      document.querySelector("html")!.style.overflowY = "scroll";
    }
    return () => {
      document.querySelector("html")!.style.overflowY = "scroll";
    };
  }, [isMobileMinified]);

  const [selected, setSelected] = useState("");

  const allHotels = useMemo(
    () => hotels.concat(unavailableHotels).concat(nearHotels),
    [hotels, nearHotels, unavailableHotels],
  );

  useEffect(() => {
    startConnection();
    search(searchParameters);

    const lastSearch = !!localStorage.getItem("last_search")
      ? (JSON.parse(localStorage.getItem("last_search")!) as {
          url: string;
          timestamp: string;
        })
      : null;

    if (
      (!!lastSearch &&
        (differenceInMinutes(new Date(), new Date(lastSearch.timestamp)) >= 1 ||
          (differenceInMinutes(new Date(), new Date(lastSearch.timestamp)) <
            1 &&
            lastSearch.url !== window.location.href))) ||
      !lastSearch
    ) {
      if (searchParameters.searchType === "box") {
        fireTagManagerEvent("search_started_map", {
          user_id: user?._id ?? null,
          categories_filter: JSON.stringify(searchParameters.filters ?? {}),
          destination: !!searchParameters.destinationLabel
            ? searchParameters.destinationLabel
            : null,
          tag: !!searchParameters.tag ? searchParameters.tag : null,
          adults: searchParameters.adults ?? null,
          children: searchParameters.childrenAge.length,
          sort_type: searchParameters.sortBy
            ? ANALYTICS_SORT_BY[
                (
                  {
                    recommended: "RECOMMENDED",
                    distance_to_cc: "DISTANCE",
                    reviews_score: "REVIEWS",
                    price: "PRICE",
                  } as const
                )[searchParameters.sortBy]
              ]
            : ANALYTICS_SORT_BY.RECOMMENDED,
          check_in: searchParameters.arrivalDate
            ? format(new Date(searchParameters.arrivalDate), "dd-MM-yyyy", {
                locale: it,
              })
            : null,
          check_out: searchParameters.departureDate
            ? format(new Date(searchParameters.departureDate), "dd-MM-yyyy", {
                locale: it,
              })
            : null,
          source: ANALYTICS_SOURCE.LIST,
          url: window.location.href,
        });
      } else {
        fireTagManagerEvent("search_started", {
          user_id: user?._id ?? null,
          categories_filter: JSON.stringify(searchParameters.filters ?? {}),
          destination: !!searchParameters.destinationLabel
            ? searchParameters.destinationLabel
            : null,
          tag: !!searchParameters.tag ? searchParameters.tag : null,
          adults: searchParameters.adults ?? null,
          children: searchParameters.childrenAge.length,
          sort_type: searchParameters.sortBy
            ? ANALYTICS_SORT_BY[
                (
                  {
                    recommended: "RECOMMENDED",
                    distance_to_cc: "DISTANCE",
                    reviews_score: "REVIEWS",
                    price: "PRICE",
                  } as const
                )[searchParameters.sortBy]
              ]
            : ANALYTICS_SORT_BY.RECOMMENDED,
          check_in: searchParameters.arrivalDate
            ? format(new Date(searchParameters.arrivalDate), "dd-MM-yyyy", {
                locale: it,
              })
            : null,
          check_out: searchParameters.departureDate
            ? format(new Date(searchParameters.departureDate), "dd-MM-yyyy", {
                locale: it,
              })
            : null,
          source: ANALYTICS_SOURCE.LIST,
          search_type:
            searchParameters.searchType === "city"
              ? searchParameters.searchLocationType
                ? ANALYTICS_SEARCH_TYPE[
                    (
                      {
                        hotel: "HOTEL",
                        known_location: "KNOWN_LOCATION",
                        nearby_location: "NEARBY_LOCATION",
                      } as const
                    )[searchParameters.searchLocationType]
                  ]
                : null
              : ANALYTICS_SEARCH_TYPE[
                  (
                    {
                      box: "MAP",
                      tag: "TAG",
                    } as const
                  )[searchParameters.searchType]
                ],
          url: window.location.href,
        });
      }
      localStorage.setItem(
        "last_search",
        JSON.stringify({
          url: window.location.href,
          timestamp: new Date().toISOString(),
        }),
      );
    }

    return () => disconnectListeners();
  }, []);

  useEffect(() => {
    if (allHotels.length > 0) {
      const observer = new MutationObserver((mutations, obs) => {
        const hotelElements = document.querySelectorAll(".hotel-result");
        if (hotelElements.length === allHotels.length) {
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }
  }, [allHotels]);

  // Calcola la larghezza della mappa in base allo spazio rimanente
  useEffect(() => {
    const updateMapWidth = () => {
      if (leftColumnRef.current) {
        const leftColumnWidth = leftColumnRef.current.offsetWidth;
        const windowWidth = window.innerWidth;
        const remainingWidth = windowWidth - leftColumnWidth - 8;
        setMapWidth(`${remainingWidth}px`);
      }
    };

    // Aggiorna la larghezza iniziale
    updateMapWidth();

    // Aggiorna la larghezza quando la finestra viene ridimensionata
    window.addEventListener("resize", updateMapWidth);

    return () => {
      window.removeEventListener("resize", updateMapWidth);
    };
  }, [leftColumnRef]);

  const mapHotelClick = async (hotelId: string) => {
    setFocussed(hotelId);
    setSelected(hotelId);

    // Find the hotel and its index in the hotels array
    setCurrIndex(allHotels.findIndex((hotel) => hotel._id === hotelId));
    const hotel = currIndex !== -1 ? allHotels[currIndex] : undefined;
    currHotelID.value = hotelId;

    const element = document.getElementById(hotelId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }

    if (hotel) {
      fireTagManagerEvent("click_on_chip", {
        collection_id: hotel._id,
        collection_name: hotel.name,
        is_available:
          hotel.availability && !hotel.availability.availabilityInfo.available,
        is_free: !hotel.isActive,
        is_loyalty_enabled:
          !!hotel.isLoyaltyEnabled && !!hotel?.isLoyaltyEnabledAdmin,
        user_id: user?._id ?? null,
        destination: !!searchParameters.destinationLabel
          ? searchParameters.destinationLabel
          : null,
      });
    }
  };

  const numberOfActiveFilters = useMemo(
    () =>
      (searchParameters.filters
        ? Object.keys(searchParameters.filters).reduce((acc, key) => {
            const typedKey = key as keyof typeof searchParameters.filters;

            if (
              [
                "certifiedOnly",
                "isLoyaltyEnabled",
                "minReviewsScore",
                "onlyHotels",
              ].includes(key)
            ) {
              if (searchParameters.filters?.[typedKey] !== undefined) {
                return acc + 1;
              }

              return acc;
            }

            if (["stars", "facilities"].includes(key)) {
              if (searchParameters.filters?.[typedKey] !== undefined) {
                return (
                  // @ts-ignore
                  acc +
                    (searchParameters.filters?.[typedKey] as Array<unknown>)
                      ?.length ?? 0
                );
              }

              return acc;
            }

            return acc;
          }, 0)
        : 0) + 0,
    [searchParameters.filters],
  );

  const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState(false);

  const [locale, setLocale] = useState<Locale>();

  useEffect(() => {
    const initAsync = async () => {
      const l = await getLocaleLanguage();

      let langValue: LANG | undefined = l as LANG | undefined;

      let locale = enUS;
      if (langValue === LANG.it) locale = it;
      if (langValue === LANG.es) locale = es;
      setLocale(locale);

      if (langValue === LANG.en) langValue = "en-gb" as any;

      setParameters({ ...searchParameters, language: langValue });
    };
    initAsync();
  }, [t]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsSearchInViewport(!(scrollTop > navbarHeight));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Call once on mount to initialize the state
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [navbarHeight]);

  useEffect(() => {
    const nav = document.getElementById("navbar");
    if (nav) {
      setNavbarHeight(nav.clientHeight);
    }
  }, []);

  const openPlusModal = () => {
    openModal({
      content: <PlusModal />,
      className:
        "h-fit self-end rounded-t-[1.25rem] lg:h-auto lg:self-center lg:rounded-3xl max-w-[400px]",
      native: isSmallScreen,
    });
  };

  const loadingProgressMessage = useMemo(() => {
    if (loadingProgress < 0.5) {
      return t("ds.loader1");
    }
    if (loadingProgress < 0.8) {
      return t("ds.loader2");
    }

    return t("ds.loader3");
  }, [loadingProgress]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsBottomDelimiterInViewport(entry.isIntersecting);
      },
      { threshold: 0.1 },
    );

    if (bottomDelimiterRef.current) {
      observer.observe(bottomDelimiterRef.current);
    }

    return () => {
      if (bottomDelimiterRef.current) {
        observer.unobserve(bottomDelimiterRef.current);
      }
    };
  }, []);

  return (
    <div
      style={{
        width: "100vw",
        minHeight: "100dvh",
        background: "#FFFFFF",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
      }}
    >
      <LoadingBar progress={loadingProgress} leftColumnRef={leftColumnRef} />
      {showMobileMap && !isxLargeScreen && (
        <motion.div
          id="mobile-map"
          className="w100 h100 position-fixed top-0 white-background rounded-2 overflow-hidden"
          style={{ zIndex: 999 }}
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ type: "spring", damping: 40, stiffness: 300 }}
        >
          <div className="absolute top-0 left-0 w-full flex items-center justify-between px-[1.125rem] h-20">
            <button
              type="button"
              className="rounded-2xl size-12 flex items-center justify-center border-none box-border bg-[#F8F8F8] ring-2 ring-white ring-inset shadow-[0px_0px_20px_5px_rgba(0,_0,_0,_0.25)]"
              style={{ zIndex: 999 }}
              onClick={() => {
                setShowMobileMap(false);
              }}
            >
              <Icon size={20} icon="close" className="close-modal" />
            </button>
            <button
              type="button"
              className="relative rounded-2xl size-12 flex items-center justify-center border-none box-border bg-[#F8F8F8] ring-2 ring-white ring-inset shadow-[0px_0px_20px_5px_rgba(0,_0,_0,_0.25)]"
              style={{ zIndex: 999 }}
              onClick={() => {
                openModal(
                  {
                    content: (
                      <FiltersModal
                        onFilter={({ filters }) => {
                          goToSearchUrl(
                            {
                              filters,
                            },
                            {
                              triggerTagManagerEvent: false,
                              source: ANALYTICS_SOURCE.MAP,
                            },
                          );
                          closeModal();
                        }}
                        source={ANALYTICS_SOURCE.MAP}
                      />
                    ),
                    className:
                      "rounded-t-3xl self-end h-[calc(100dvh-1rem)] lg:h-auto lg:self-center lg:rounded-3xl",
                  },
                  { hideModalCloseBtn: true },
                );
              }}
            >
              <IconFilter className="size-[0.938rem] text-black" />
              {numberOfActiveFilters > 0 && (
                <div className="absolute top-0 right-0 translate-x-1 -translate-y-1 aspect-square rounded-full bg-black size-5 text-[0.625rem] font-medium text-white flex items-center justify-center text-center">
                  {numberOfActiveFilters}
                </div>
              )}
            </button>
          </div>
          <HotelsMap
            onClick={mapHotelClick}
            selected={selected}
            hotels={allHotels}
            isSmallScreen={isSmallScreen}
          />
          <MapInfoHotel
            hotels={allHotels}
            currIndex={currIndex}
            onHotelClick={(hotel) => {
              CollectionController.clickOnCollection(hotel._id, {
                btn: "detail_page",
                directPrice: hotel.availability?.availabilityInfo.value,
                cutPrice: undefined,
                bookingPrice: undefined,
                hotelsPrice: "N/A",
                bookingComId: hotel.bookingId,
                checkin: searchParameters.arrivalDate,
                checkout: searchParameters.departureDate,
              });
              fireTagManagerEvent("open_modal", {
                destination: !!searchParameters.destinationLabel
                  ? searchParameters.destinationLabel
                  : null,
                amount: hotel.availability
                  ? Number(hotel.availability.availabilityInfo.value.toFixed(0))
                  : 0,
                collection_id: hotel._id,
                collection_name: hotel.name,
                is_available:
                  hotel.availability &&
                  hotel.availability.availabilityInfo.available,
                is_free: !hotel.isActive,
                is_loyalty_enabled:
                  !!hotel.isLoyaltyEnabled && !!hotel?.isLoyaltyEnabledAdmin,
                list_position: null,
                user_id: user?._id ?? null,
                stars:
                  hotel.stars && Number(hotel.stars) !== 0
                    ? Number(hotel.stars)
                    : null,
                tag: !!searchParameters.tag ? searchParameters.tag : null,
                adults: searchParameters.adults ?? null,
                children: searchParameters.childrenAge.length,
                sort_type: searchParameters.sortBy
                  ? ANALYTICS_SORT_BY[
                      (
                        {
                          recommended: "RECOMMENDED",
                          distance_to_cc: "DISTANCE",
                          reviews_score: "REVIEWS",
                          price: "PRICE",
                        } as const
                      )[searchParameters.sortBy]
                    ]
                  : ANALYTICS_SORT_BY.RECOMMENDED,
                categories_filter: JSON.stringify(
                  searchParameters.filters ?? {},
                ),
                check_in: searchParameters.arrivalDate
                  ? format(
                      new Date(searchParameters.arrivalDate),
                      "dd-MM-yyyy",
                      {
                        locale: it,
                      },
                    )
                  : null,
                check_out: searchParameters.departureDate
                  ? format(
                      new Date(searchParameters.departureDate),
                      "dd-MM-yyyy",
                      {
                        locale: it,
                      },
                    )
                  : null,
                includes_benefits: hotel?.advantagesOnDirectWebsite?.length > 0,
              });
              if (hotel.slug) {
                return window.open(
                  `${String(process.env.REACT_APP_FRONTEND_URI)}/${hotel.slug}${
                    urlParams ? `?${urlParams}` : ""
                  }`,
                  "_blank",
                );
              }
              window.open(
                `${String(process.env.REACT_APP_FRONTEND_URI)}/${hotel._id}${
                  urlParams ? `?${urlParams}` : ""
                }`,
                "_blank",
              );
            }}
            setCurrIndex={(i) => {
              setCurrIndex(i);
              if (allHotels?.[i]?._id) {
                setSelected(allHotels[i]._id);
              }
            }}
          />
        </motion.div>
      )}
      <SearchDrawer
        isSearchDrawerOpen={isSearchDrawerOpen}
        setIsSearchDrawerOpen={setIsSearchDrawerOpen}
        locale={locale}
      />

      <div
        ref={leftColumnRef}
        className="gap-4 relative"
        // lg:min-w-[810px]
        style={{
          marginTop: isSmallScreen ? navH - 6 : navH,
          padding: isSmallScreen ? "18px 0" : "18px 0",
          width: !isxLargeScreen
            ? "100%"
            : !isReallyLargeScreen
            ? "50%"
            : "40%",
          display: "flex",
          flexDirection: "column",
          minHeight: "100dvh",
        }}
      >
        <div>
          {isSmallScreen && (
            <div
              className="py-2 px-4 bg-white w-full border-gray-100"
              style={{
                position: !isSearchInViewport ? "fixed" : "unset",
                zIndex: !isSearchInViewport ? 49 : 0,
                paddingTop: !isSearchInViewport ? "2rem" : 0,
                top: 0,
                borderWidth: !isSearchInViewport ? 1 : 0,
                borderStyle: !isSearchInViewport ? "solid" : "unset",
                boxShadow: !isSearchInViewport
                  ? "0px -3px 10px 0px #000000"
                  : "none",
                transition: "top 100ms ease 0s",
              }}
            >
              <article className="flex items-center h-14 gap-2">
                <button
                  type="button"
                  className="bg-[#F3F3F3] rounded-2xl flex-1 px-4 flex flex-col justify-center border-none h-full text-black"
                  onClick={() => setIsSearchDrawerOpen(true)}
                >
                  <h2 className="text-sm font-medium text-left mb-0">
                    {searchParameters.searchType === "tag"
                      ? t(`ds.destination_category_${searchParameters.tag}`)
                      : !!searchParameters.destinationLabel &&
                        searchParameters.destinationLabel !== ""
                      ? searchParameters.destinationLabel
                      : searchParameters.searchType === "box"
                      ? t("ds.map_area")
                      : "-"}
                  </h2>
                  <p
                    className="text-xs text-[#747474] text-left"
                    style={{
                      width: "max-content",
                    }}
                  >
                    {`${
                      searchParameters.arrivalDate
                        ? format(
                            new Date(searchParameters.arrivalDate),
                            "iii dd MMM",
                            {
                              locale: locale,
                            },
                          )
                        : "-"
                    } - ${
                      searchParameters.departureDate
                        ? format(
                            new Date(searchParameters.departureDate),
                            "iii dd MMM",
                            {
                              locale: locale,
                            },
                          )
                        : "-"
                    } ∙ ${
                      searchParameters.adults +
                      searchParameters.childrenAge.length
                    } ${t("ds.guest", {
                      count:
                        searchParameters.adults +
                        searchParameters.childrenAge.length,
                    })}`}
                  </p>
                  {/* <p className="text-xs text-[#747474] text-left">{`${searchParameters.arrivalDate} - ${searchParameters.departureDate} ∙ ${searchParameters.adults + searchParameters.childrenAge.length} ${t("ds.guest", {count: searchParameters.adults + searchParameters.childrenAge.length})}`}</p> */}
                </button>
                <div className="relative w-14 h-full shrink-0">
                  {numberOfActiveFilters > 0 && (
                    <div className="absolute w-2 h-5 bg-[#F3F3F3] -translate-x-full top-1/2 -translate-y-1/2 before:content-[''] before:absolute before:size-2 before:bg-white before:rounded-full before:left-1/2 before:-translate-x-1/2 before:-translate-y-2/3 after:content-[''] after:absolute after:size-2 after:bg-white after:rounded-full after:left-1/2 after:-translate-x-1/2 after:bottom-0 after:translate-y-2/3" />
                  )}
                  <button
                    type="button"
                    className="bg-[#F3F3F3] rounded-2xl size-full flex items-center justify-center border-none"
                    onClick={() => {
                      openModal(
                        {
                          content: (
                            <FiltersModal
                              onFilter={({ filters }) => {
                                goToSearchUrl(
                                  { filters },
                                  {
                                    triggerTagManagerEvent: false,
                                    source: ANALYTICS_SOURCE.LIST,
                                  },
                                );
                                closeModal();
                              }}
                              source={ANALYTICS_SOURCE.LIST}
                            />
                          ),
                          className:
                            "rounded-t-3xl self-end h-[calc(100dvh-1rem)] lg:h-auto lg:self-center lg:rounded-3xl",
                        },
                        { hideModalCloseBtn: true },
                      );
                    }}
                  >
                    <IconFilter className="size-4 text-black" />
                  </button>
                  {numberOfActiveFilters > 0 && (
                    <div className="absolute top-0 right-0 translate-x-0.5 -translate-y-0.5 aspect-square rounded-full bg-black size-5 text-[0.625rem] font-medium text-white flex items-center justify-center text-center">
                      {numberOfActiveFilters}
                    </div>
                  )}
                </div>
              </article>
            </div>
          )}
        </div>
        <DirectSearchBadge
          containerClassName="px-4"
          isLoading={isLoading}
          openPlusModal={openPlusModal}
        />
        <div className="px-4 w-full flex flex-row justify-between items-center gap-4">
          <button
            type="button"
            className={cn(
              "w-full rounded-2xl flex flex-col justify-center bg-transparent min-h-12",
              isLoading &&
                "cursor-auto lg:border lg:px-4 px-4 py-2 border border-[#F3F3F3]",
              !isLoading && "border-0",
            )}
            onClick={() => {
              if (isLoading) {
                return;
              }
              openModal({
                content: (
                  <div className="flex flex-col gap-4 px-6 pb-10 lg:pt-10">
                    <h4 className="text-base font-medium">
                      {t("ds.pricing_modal_title")}
                    </h4>
                    <p className="text-sm font-medium text-[#747474]">
                      {t("ds.pricing_modal_description")}
                    </p>
                  </div>
                ),
                className:
                  "h-fit self-end rounded-t-[1.25rem] lg:h-auto lg:self-center lg:rounded-3xl",
                native: isSmallScreen,
              });
            }}
          >
            {isLoading ? (
              <div className="flex gap-1 justify-center">
                <img src={loadingGif} alt="loading" className="w-4 h-4" />
                <p className="font-normal text-xs text-black">
                  {loadingProgressMessage}
                </p>
              </div>
            ) : null}
            {!isLoading && (
              <div className="flex flex-wrap items-center gap-1">
                <span className="text-sm text-left text-[#747474]">
                  {t("ds.pricing_card_action.0")}
                </span>
                <span className="text-sm text-left text-[#747474]">
                  {t("ds.pricing_card_action.1")}
                </span>
                <span className="text-sm text-left text-[#747474]">
                  {t("ds.pricing_card_action.2")}
                </span>
                <IconInfo className="size-3 stroke-black shrink-0" />
              </div>
            )}
          </button>
          {!isLoading && (
            <Form.Select
              size="sm"
              className={cn(
                "border-[#E8E8E8] rounded-xl pl-3 py-2 pr-2 text-sm mr-0",
                searchParameters.sortBy === SortHotelsBy.RECOMMENDED && "w-40",
                searchParameters.sortBy === SortHotelsBy.PRICE && "w-52",
                searchParameters.sortBy === SortHotelsBy.REVIEWS && "w-60",
                searchParameters.sortBy === SortHotelsBy.DISTANCE_TO_CC &&
                  "w-28",
              )}
              value={searchParameters.sortBy}
              onChange={(e) =>
                handleSortChange(
                  e.target.value as SortHotelsBy,
                  ANALYTICS_SOURCE.LIST,
                )
              }
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
            </Form.Select>
          )}
        </div>
        {!isLoading && (
          <div className="px-4 hidden sm:flex lg:hidden xl:flex">
            <div className="horizontal-divider !mt-0" />
          </div>
        )}
        <div
          className={cn("pb-16 lg:pb-4", allResults && "pb-0")}
          style={{
            marginTop: !isMobileMinified ? searchbarHeight : 0,
            position: "relative",
          }}
        >
          {allHotels.length > 0 && (
            <div className="flex flex-col gap-4">
              {!searchParameters.collectionId && hotels.length === 0 ? (
                <div className="flex flex-col gap-8 lg:px-4">
                  <div className="flex flex-col px-4 py-6 bg-[#F8F8F8] w-screen lg:w-full lg:rounded-3xl">
                    <h4 className="text-sm font-medium mb-0 text-black">
                      {t("ds.no_results_title", {
                        place: searchParameters.destinationLabel,
                      })}
                    </h4>
                    <p className="text-xs font-medium text-[#747474]">
                      {t("ds.no_results_subtitle", {
                        place: searchParameters.destinationLabel,
                      })}
                    </p>
                  </div>
                </div>
              ) : searchParameters.collectionId &&
                nearHotels.length === 0 &&
                unavailableHotels.length === 1 ? (
                <HotelResult
                  openPlusModal={openPlusModal}
                  onSelect={(id) => {
                    setSelected(id);
                  }}
                  onCardClick={(hotel) => {
                    if (hotel.slug) {
                      return window.open(
                        `${String(process.env.REACT_APP_FRONTEND_URI)}/${
                          hotel.slug
                        }${urlParams ? `?${urlParams}` : ""}`,
                        "_blank",
                      );
                    }
                    window.open(
                      `${String(process.env.REACT_APP_FRONTEND_URI)}/${
                        hotel._id
                      }${urlParams ? `?${urlParams}` : ""}`,
                      "_blank",
                    );
                  }}
                  key={`hotel_${unavailableHotels[0]._id}_${unavailableHotels[0].index}`}
                  hotel={unavailableHotels[0]}
                  dest_label={searchParameters.destinationLabel}
                  setCurrentSelected={setCurrentSelected}
                  listPosition={allHotels.findIndex(
                    (hotel) => hotel._id === unavailableHotels[0]._id,
                  )}
                  currentSelected={selected}
                />
              ) : null}
              {hotels
                .slice(0, Math.round(hotels.length / 2))
                .map((h, index) => (
                  <div className="flex flex-col">
                    <HotelResult
                      openPlusModal={openPlusModal}
                      onSelect={(id) => {
                        setSelected(id);
                      }}
                      onCardClick={(hotel) => {
                        if (hotel.slug) {
                          return window.open(
                            `${String(process.env.REACT_APP_FRONTEND_URI)}/${
                              hotel.slug
                            }${urlParams ? `?${urlParams}` : ""}`,
                            "_blank",
                          );
                        }
                        window.open(
                          `${String(process.env.REACT_APP_FRONTEND_URI)}/${
                            hotel._id
                          }${urlParams ? `?${urlParams}` : ""}`,
                          "_blank",
                        );
                      }}
                      key={`hotel_${h._id}`}
                      hotel={h}
                      dest_label={searchParameters.destinationLabel}
                      setCurrentSelected={setCurrentSelected}
                      listPosition={allHotels.findIndex(
                        (hotel) => hotel._id === h._id,
                      )}
                      currentSelected={selected}
                    />
                    <div
                      data-hide={
                        index ===
                        hotels.slice(0, Math.round(hotels.length / 2)).length -
                          1
                      }
                      className="lg:px-0 sm:px-4 xl:px-4 data-[hide=true]:hidden mt-2.5"
                    >
                      <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                    </div>
                  </div>
                ))}

              {isLoading ? null : hotels.length > 0 &&
                unavailableHotels.length > 0 ? (
                <CarouselWrapper
                  title={t("ds.carousel.no_avail")}
                  subtitle={t("ds.carousel.no_avail_sub")}
                >
                  <UnavailableCarousel
                    hotels={unavailableHotels}
                    urlParams={urlParams}
                  />
                </CarouselWrapper>
              ) : hotels.length > 0 ? (
                <div className="lg:px-0 sm:px-4 xl:px-4 mt-2.5">
                  <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                </div>
              ) : null}
              {hotels.slice(Math.round(hotels.length / 2)).map((h, index) => (
                <div className="flex flex-col">
                  <HotelResult
                    openPlusModal={openPlusModal}
                    onSelect={(id) => {
                      setSelected(id);
                    }}
                    onCardClick={(hotel) => {
                      if (hotel.slug) {
                        return window.open(
                          `${String(process.env.REACT_APP_FRONTEND_URI)}/${
                            hotel.slug
                          }${urlParams ? `?${urlParams}` : ""}`,
                          "_blank",
                        );
                      }
                      window.open(
                        `${String(process.env.REACT_APP_FRONTEND_URI)}/${
                          hotel._id
                        }${urlParams ? `?${urlParams}` : ""}`,
                        "_blank",
                      );
                    }}
                    key={`hotel_${h._id}`}
                    hotel={h}
                    dest_label={searchParameters.destinationLabel}
                    setCurrentSelected={setCurrentSelected}
                    listPosition={allHotels.findIndex(
                      (hotel) => hotel._id === h._id,
                    )}
                    currentSelected={selected}
                  />
                  <div
                    data-hide={
                      index ===
                      hotels.slice(Math.round(hotels.length / 2)).length - 1
                    }
                    className="lg:px-0 sm:px-4 xl:px-4 data-[hide=true]:hidden mt-5 lg:mt-5 sm:mt-2.5 xl:mt-2.5"
                  >
                    <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                  </div>
                </div>
              ))}
              {nearHotels.length > 0 && (
                <div className="flex flex-col gap-4 w-full">
                  {hotels.length > 0 && (
                    <div className="lg:px-4 ">
                      <div className="flex flex-col px-4 py-6 bg-[#F8F8F8] w-screen lg:w-full lg:rounded-3xl">
                        <h4 className="text-sm font-medium mb-0 text-black">
                          {t("ds.similar_results_title")}
                        </h4>
                        <p className="text-xs font-medium text-[#747474]">
                          {t("ds.similar_results_subtitle", {
                            place: searchParameters.destinationLabel,
                          })}
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="flex flex-col gap-4">
                    {nearHotels
                      .slice(0, Math.round(nearHotels.length / 3))
                      .map((h, index) => (
                        <div className="flex flex-col">
                          <HotelResult
                            openPlusModal={openPlusModal}
                            onSelect={(id) => {
                              setSelected(id);
                            }}
                            onCardClick={(hotel) => {
                              if (hotel.slug) {
                                return window.open(
                                  `${String(
                                    process.env.REACT_APP_FRONTEND_URI,
                                  )}/${hotel.slug}${
                                    urlParams ? `?${urlParams}` : ""
                                  }`,
                                  "_blank",
                                );
                              }
                              window.open(
                                `${String(
                                  process.env.REACT_APP_FRONTEND_URI,
                                )}/${hotel._id}${
                                  urlParams ? `?${urlParams}` : ""
                                }`,
                                "_blank",
                              );
                            }}
                            key={`hotel_${h._id}_${index}`}
                            hotel={h}
                            dest_label={searchParameters.destinationLabel}
                            setCurrentSelected={setCurrentSelected}
                            listPosition={allHotels.findIndex(
                              (hotel) => hotel._id === h._id,
                            )}
                            currentSelected={selected}
                          />
                          <div
                            data-hide={
                              index ===
                              nearHotels.slice(
                                0,
                                Math.round(nearHotels.length / 3),
                              ).length -
                                1
                            }
                            className="lg:px-0 sm:px-4 xl:px-4 data-[hide=true]:hidden mt-2.5"
                          >
                            <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                          </div>
                        </div>
                      ))}

                    {isLoading ? null : hotels.length === 0 &&
                      unavailableHotels.length > 0 ? (
                      <CarouselWrapper
                        title={t("ds.carousel.other_dates", {
                          place: searchParameters.destinationLabel,
                        })}
                        subtitle={t("ds.carousel.other_dates_sub")}
                      >
                        <UnavailableCarousel
                          hotels={unavailableHotels}
                          urlParams={urlParams}
                        />
                      </CarouselWrapper>
                    ) : (
                      <div className="lg:px-0 sm:px-4 xl:px-4 mt-2.5">
                        <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                      </div>
                    )}

                    {nearHotels
                      .slice(
                        Math.round(nearHotels.length / 3),
                        Math.round(nearHotels.length / 3) * 2,
                      )
                      .map((h, index) => (
                        <div className="flex flex-col">
                          <HotelResult
                            openPlusModal={openPlusModal}
                            onSelect={(id) => {
                              setSelected(id);
                            }}
                            onCardClick={(hotel) => {
                              if (hotel.slug) {
                                return window.open(
                                  `${String(
                                    process.env.REACT_APP_FRONTEND_URI,
                                  )}/${hotel.slug}${
                                    urlParams ? `?${urlParams}` : ""
                                  }`,
                                  "_blank",
                                );
                              }
                              window.open(
                                `${String(
                                  process.env.REACT_APP_FRONTEND_URI,
                                )}/${hotel._id}${
                                  urlParams ? `?${urlParams}` : ""
                                }`,
                                "_blank",
                              );
                            }}
                            key={`hotel_${h._id}_${index}`}
                            hotel={h}
                            dest_label={searchParameters.destinationLabel}
                            setCurrentSelected={setCurrentSelected}
                            listPosition={allHotels.findIndex(
                              (hotel) => hotel._id === h._id,
                            )}
                            currentSelected={selected}
                          />
                          <div
                            data-hide={
                              index ===
                              nearHotels.slice(
                                Math.round(nearHotels.length / 3),
                                Math.round(nearHotels.length / 3) * 2,
                              ).length -
                                1
                            }
                            className="lg:px-0 sm:px-4 xl:px-4 data-[hide=true]:hidden mt-2.5"
                          >
                            <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                          </div>
                        </div>
                      ))}

                    {isLoading ? null : nearHotels.length > 0 ? (
                      <CarouselWrapper
                        title={t("ds.carousel.tag")}
                        subtitle={t("ds.carousel.tag_sub")}
                      >
                        <TagsCarousel />
                      </CarouselWrapper>
                    ) : (
                      <div className="lg:px-0 sm:px-4 xl:px-4 mt-2.5">
                        <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                      </div>
                    )}
                    {nearHotels
                      .slice(Math.round(nearHotels.length / 3) * 2)
                      .map((h, index) => (
                        <div className="flex flex-col">
                          <HotelResult
                            openPlusModal={openPlusModal}
                            onSelect={(id) => {
                              setSelected(id);
                            }}
                            onCardClick={(hotel) => {
                              if (hotel.slug) {
                                return window.open(
                                  `${String(
                                    process.env.REACT_APP_FRONTEND_URI,
                                  )}/${hotel.slug}${
                                    urlParams ? `?${urlParams}` : ""
                                  }`,
                                  "_blank",
                                );
                              }
                              window.open(
                                `${String(
                                  process.env.REACT_APP_FRONTEND_URI,
                                )}/${hotel._id}${
                                  urlParams ? `?${urlParams}` : ""
                                }`,
                                "_blank",
                              );
                            }}
                            key={`hotel_${h._id}_${index}`}
                            hotel={h}
                            dest_label={searchParameters.destinationLabel}
                            setCurrentSelected={setCurrentSelected}
                            listPosition={allHotels.findIndex(
                              (hotel) => hotel._id === h._id,
                            )}
                            currentSelected={selected}
                          />
                          <div
                            data-hide={
                              index ===
                              nearHotels.slice(
                                Math.round(nearHotels.length / 3) * 2,
                              ).length -
                                1
                            }
                            className="lg:px-0 sm:px-4 xl:px-4 data-[hide=true]:hidden mt-2.5"
                          >
                            <div className="bg-[#F8F8F8] h-[0.375rem] lg:bg-[#F8F8F8] lg:h-[0.375rem] sm:my-2.5 xl:my-2.5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {!allResults && !isLoading && (
            <div className="flex w-full justify-center mt-12">
              <button
                onClick={loadMore}
                className="bg-white border border-black text-black px-5 py-3.5 rounded-2xl text-sm font-medium"
              >
                {t("ds.load_more_results")}
              </button>
            </div>
          )}

          {isLoading && <ResultSkeletonList isxLargeScreen={isxLargeScreen} />}

          {allHotels.length === 0 && !isLoading && (
            <CarouselWrapper
              title={t("ds.carousel.no_results")}
              subtitle={t("ds.carousel.no_results_sub")}
            >
              <TagsCarousel />
            </CarouselWrapper>
          )}
        </div>
        {!isxLargeScreen ? (
          <button
            type="button"
            onClick={() => setShowMobileMap(true)}
            className="fixed bottom-4 left-1/2 -translate-x-1/2 z-10 box-border bg-[#F8F8F8] ring-4 ring-inset ring-white shadow-[0px_0px_20px_5px_rgba(0,_0,_0,_0.25)] border-none text-xs font-medium px-5 py-3.5 rounded-xl text-black"
          >
            {t("ds.map")}
          </button>
        ) : null}
        <div
          ref={bottomDelimiterRef}
          className={cn(
            "w-full h-10 absolute bottom-0 left-0 pointer-events-none",
          )}
        />
      </div>
      <div
        style={{
          display: "flex",
          height: `calc(100dvh - ${navH}px)`,
          alignItems: "flex-end",
          justifyContent: "flex-start",
        }}
      >
        {isxLargeScreen && (
          <div
            id="map-container"
            ref={mapRef}
            style={{
              position:
                isFixed && !isBottomDelimiterInViewport ? "fixed" : "relative",
              top: 0,
              bottom: 0,
              right: 0,
              marginTop: navH,
              // borderRadius: "20px",
              overflow: "hidden",
              height: `calc(100dvh - ${navH}px)`,
              width: mapWidth,
              flex: isFixed ? "0 0 auto" : "",
            }}
          >
            <HotelsMap
              onClick={async (hotelId) => {
                setFocussed(hotelId);
                setSelected(hotelId);
                const element = document.getElementById(hotelId);
                const hotel = allHotels.find((hotel) => hotel._id === hotelId);

                if (element) {
                  element.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  });
                }

                if (hotel) {
                  fireTagManagerEvent("click_on_chip", {
                    collection_id: hotel._id,
                    collection_name: hotel.name,
                    is_available:
                      hotel.availability &&
                      hotel.availability.availabilityInfo.available,
                    is_free: !hotel.isActive,
                    is_loyalty_enabled:
                      !!hotel.isLoyaltyEnabled &&
                      !!hotel?.isLoyaltyEnabledAdmin,
                    user_id: user?._id ?? null,
                    destination: !!searchParameters.destinationLabel
                      ? searchParameters.destinationLabel
                      : null,
                  });
                }
              }}
              isSmallScreen={isSmallScreen}
              selected={selected}
              hotels={allHotels}
            />
            <DsFeedback />
          </div>
        )}
      </div>
    </div>
  );
}
